import React, { useState } from 'react';
import '../css/apnipolicydetailspage.css';

const ApniPolicyDetailsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="apnipolicy-container">
      <div className="apnipolicy-info">
        <h2 className="apnipolicy-heading">
          <span style={{ color: "#192437" }}>What is </span>
          <span style={{ color: "#F5A526" }}>Apni Policy Samjho?</span>
        </h2>
        <p className="apnipolicy-text">
          Insurance policies are often filled with complex terms, hidden clauses, and overwhelming details.
          <strong> “Apni Policy Samjho” </strong> is an initiative by our team to help you clearly understand your policy documents and benefits.
          We explain everything in simple language — from what your policy covers, to what it doesn’t, and what to do when a claim arises.
        </p>

        <h2 className="apnipolicy-subheading">
          <span style={{ color: "#192437" }}>Why </span>
          <span style={{ color: "#F5A526" }}>Choose Us?</span>
        </h2>
        <ul className="apnipolicy-benefits">
          <li className="apnipoints"><strong>Policy Decoding:</strong> We analyze your uploaded policy and translate the legal terms into simple language.</li>
          <li className="apnipoints"><strong>Genuine Human Support:</strong> No chatbots. You talk to real people with expertise in health and general insurance.</li>
          <li className="apnipoints"><strong>Save Time and Reduce Risk:</strong> Understand exclusions and limitations beforehand to avoid claim rejections.</li>
          <li className="apnipoints"><strong>Tailored Advice:</strong> Get suggestions for coverage gaps, hidden clauses, and suitable add-ons to enhance your protection.</li>
        </ul>

        <p className="apnipolicy-text spaced-text">
          Don’t just own a policy — <strong>understand</strong> it. Fill out the form below and let our experts help you.
        </p>
      </div>
      <div className="apnipolicy-form-div">
        <h4 className="apnipolicy-form-heading">
          <span style={{ color: "#FFF" }}>Get Started with Your  </span>
          <span style={{ color: "#F5A526" }}>   Policy Understanding</span>
        </h4>

        <form onSubmit={(e) => { e.preventDefault(); setIsContactModalOpen(false); }}>
          <div className="bottom-form-row">
            <div>
              <label>Full Name</label>
              <input type="text" placeholder="Enter your name" required />
            </div>
            <div>
              <label>Email ID</label>
              <input type="email" placeholder="Enter your email" required />
            </div>
          </div>

          <div className="bottom-form-row">
            <div>
              <label>Mobile No</label>
              <input type="tel" placeholder="Enter your mobile number" required />
            </div>
            <div>
              <label>Enter Your Preference Date</label>
              <input type="date" required />
            </div>
          </div>

          <div className="bottom-form-row">
            <div>
              <label>Enter Your Preference Time</label>
              <input type="time" required />
            </div>
            <div>
              <label>Upload Your Policy Documents</label>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" required />
            </div>
          </div>

          <button type="submit" className="apnipolicy-submit-btn">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ApniPolicyDetailsPage;
